var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c('AppConfigTabs',{attrs:{"empAppSettings":_vm.empAppSettings,"appConfigOptions":_vm.appConfigOptions},on:{"update-config":_vm.updateAppConfig,"save-filters":_vm.saveFilterChanges,"custom-activity-steps":_vm.updateCustomActivitySteps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }